import { useState } from "react";
import { toast } from "sonner";
import { MessageSquareReply } from "lucide-react";
import api, { formatApiError } from "../lib/api";
import { Button } from "./ui/button";
import { Textarea } from "./ui/textarea";

export default function RatingReply({ rating, supplierName = "Fornitore", canReply, onReplied }) {
  const [open, setOpen] = useState(false);
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);

  if (rating.reply) {
    return (
      <div className="mt-2 ml-3 border-l-2 border-emerald-300 pl-3" data-testid={`rating-reply-${rating.id}`}>
        <div className="text-[10px] font-mono uppercase tracking-widest text-emerald-700">Risposta di {supplierName}{rating.reply_at ? ` · ${new Date(rating.reply_at).toLocaleDateString("it-IT")}` : ""}</div>
        <div className="mt-0.5 text-sm text-slate-700">{rating.reply}</div>
      </div>
    );
  }
  if (!canReply) return null;

  const send = async () => {
    if (!text.trim()) return toast.error("Scrivi una risposta");
    setBusy(true);
    try {
      await api.post(`/ratings/${rating.id}/reply`, { reply: text.trim() });
      toast.success("Risposta pubblicata");
      setOpen(false); setText(""); onReplied?.();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <div className="mt-2">
      {!open ? (
        <button type="button" onClick={() => setOpen(true)} className="inline-flex items-center gap-1 text-xs font-semibold text-emerald-700 hover:underline" data-testid={`reply-rating-button-${rating.id}`}>
          <MessageSquareReply className="w-3.5 h-3.5" /> Rispondi pubblicamente
        </button>
      ) : (
        <div className="space-y-2">
          <Textarea rows={2} maxLength={600} value={text} onChange={e => setText(e.target.value)} placeholder="Grazie per il feedback..." data-testid={`reply-rating-input-${rating.id}`} />
          <div className="flex gap-2">
            <Button size="sm" onClick={send} disabled={busy} className="ga-btn-primary rounded-full" data-testid={`reply-rating-submit-${rating.id}`}>{busy ? "Invio..." : "Pubblica risposta"}</Button>
            <Button size="sm" variant="ghost" onClick={() => setOpen(false)} className="rounded-full">Annulla</Button>
          </div>
        </div>
      )}
    </div>
  );
}
